import { SelectOption } from '@globaleris/ui.library'
import { EnumTipoConfiguracion } from '../../api/oData/enums/enumTipoConfiguracion'
import { getActiveCompany } from '../../redux'
import TemplateSettings, { TemplateSettingsAdd } from './templateSettings.model'

export const templateSettingsListItemsMapper = (items: any[]): TemplateSettings[] => {
  return items && items.map(templateSettingsListItemMapper)
}

export const templateSettingsListItemMapper = (item: any): TemplateSettings => {
  return (
    item && {
      id: item.id,
      templateType: item.templateType,
      templateSubType: item.templateSubType,
      description: item.description,
      products: item.products.map(p => p.value),
      contractType: item.contractType.map(p => p.value),
      client: item.client.map(p => p.value),
      language: item.language,
      invoiceType: item.invoiceType,
      currentVersion: item.currentVersion,
      idDetail: item.idDetail,
      invoiceClass: item.invoiceClass
    }
  )
}

export const templateSettingsListItemMapperEdit = (
  item: any,
  products: SelectOption[],
  contractTypes: SelectOption[],
  clients: SelectOption[]
): TemplateSettings => {
  return (
    item && {
      id: item.id,
      templateType: item.templateType,
      templateSubType: item.templateSubType,
      description: item.description,
      products: products.filter(x => item.products.map(c => parseInt(c)).includes(x.value)),
      contractType: contractTypes.filter(x =>
        item.contractType.map(c => parseInt(c)).includes(x.value)
      ),
      client: clients.filter(x => item.client.map(c => parseInt(c)).includes(x.value)),
      language: item.language,
      invoiceType: item.invoiceType,
      currentVersion: item.currentVersion,
      idDetail: item.idDetail,
      invoiceClass: item.invoiceClass
    }
  )
}
export const templateSettingsListItemMapperAdd = (
  item: TemplateSettingsAdd,
  products?: SelectOption[],
  contractTypes?: SelectOption[],
  clients?: SelectOption[]
): TemplateSettingsAdd => {
  return (
    item && {
      id: item.id,
      templateType: item.templateType,
      templateSubType: item.templateSubType,
      description: item.description,
      products: products?.filter(x => item?.products?.map(c => parseInt(c)).includes(+x.value)),
      contractType: contractTypes?.filter(x =>
        item?.contractType?.map(c => parseInt(c)).includes(+x.value)
      ),
      client: clients?.filter(x => item?.client?.map(c => parseInt(c)).includes(+x.value)),
      language: item.language,
      invoiceType: item.invoiceType,
      currentVersion: item.currentVersion,
      invoiceClass: item.invoiceClass,
      company: getActiveCompany()?.id
    }
  )
}

export const productsListItemMapper = (item: any): SelectOption => {
  return (
    item && {
      label: item.label,
      value: item.value
    }
  )
}

export const listItemMapper = (items: any[]): SelectOption[] => {
  return items && items.map(itemMapper)
}

export const itemMapper = (item: any): SelectOption => {
  return (
    item && {
      value: item.value,
      label: item.label
    }
  )
}

export const filterTemplatesData = (tableData?: TemplateSettings[]) => {
  if (tableData)
    return tableData.filter(element => element.templateType === EnumTipoConfiguracion.Plantilla)
}

export const filterWidgetData = (tableData?: TemplateSettings[]) => {
  if (tableData)
    return tableData.filter(element => element.templateType === EnumTipoConfiguracion.Widget)
}
